/**
 * Urban Nest Quest — Brand & Site Configuration
 * Single source of truth for brand colors, contact info, copy,
 * and the consumer-facing "Urban Nest Quest, powered by {brokerage}" hierarchy.
 * BROKERAGE is the single frontend source for the sponsoring broker (backend: BROKERAGE_NAME env).
 */

const BROKERAGE = "RaiderX";

export const BRAND = {
  // Primary consumer brand
  name: "Urban Nest Quest",
  tagline: "Houston Apartment Locating",

  // Sponsoring brokerage (legal/footer line). Legal disclosure text pending approval.
  brokerage: BROKERAGE,
  brokerageLine: `Powered by ${BROKERAGE}`,
  agentAttribution: `Bryan Spann – ${BROKERAGE}`,

  // Colors — Urban Nest Quest palette (public-facing only)
  colors: {
    navy: "#1F2A44",        // Deep Urban Navy
    charcoal: "#333333",    // Modern Charcoal
    gold: "#C8A96B",         // Luxury Gold (primary accent)
    goldDark: "#B5915A",     // Hover/active gold
    softGray: "#D9D9D9",     // Soft Concrete Gray
    white: "#FFFFFF",
    offWhite: "#FAFAF7",     // Subtle warm background
  },

  // Contact (kept consistent across the platform)
  phone: "(936) 224-1484",
  phoneHref: "tel:9362241484",
  smsHref: "sms:9362241484",
  email: "Bryan@UrbanNestQuest.com",
  emailHref: "mailto:Bryan@UrbanNestQuest.com",

  // Booking
  calendlyUrl: "https://calendly.com/urbannestquest/30min",

  // Texas-required TREC disclosures (RaiderX-issued IABS + TREC Consumer Protection Notice)
  trecIabsUrl: "https://www.raiderx.net/api/iabs/b2f12a9e-eb3d-4bc3-ae43-0b7e0ec4a3b2",
  trecCpnUrl: "https://www.trec.texas.gov/forms/consumer-protection-notice",
};

// SEO keyword sets, used across new pages for meta + body content.
export const SEO_KEYWORDS = {
  apartmentSearch: [
    "Houston Apartments", "Houston Apartment Locator", "Apartment Finder Houston",
    "Apartments Near Energy Corridor", "Apartments Near Downtown Houston",
  ],
  luxury: [
    "Luxury Apartments Houston", "High Rise Apartments Houston",
    "Houston Penthouse Rentals", "Luxury Apartment Locator Houston",
  ],
  homes: [
    "Houston Homes for Rent", "Houston Single Family Rentals",
    "Townhomes for Rent Houston", "Rental Houses Houston",
  ],
  relocation: [
    "Houston Relocation Services", "Moving to Houston", "Houston Apartment Locator",
    "Houston Corporate Relocation",
  ],
};
